import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import type { CountryCode } from 'libphonenumber-js/min';

const DEFAULT_PHONE_REGION: CountryCode = 'AR';

export function normalizePhoneNumberToE164(
  value: string | null | undefined,
  defaultRegion: CountryCode = DEFAULT_PHONE_REGION
): Promise<string | null> {
  if (!value?.trim()) {
    return Promise.resolve(null);
  }

  return import('libphonenumber-js/min').then(({ parsePhoneNumberFromString }) => {
    const phoneNumber = parsePhoneNumberFromString(value.trim(), defaultRegion);

    return phoneNumber?.isValid() ? phoneNumber.number : null;
  });
}

export function phoneNumberValidator(defaultRegion: CountryCode = DEFAULT_PHONE_REGION): AsyncValidatorFn {
  return async (control: AbstractControl): Promise<ValidationErrors | null> => {
    const value = control.value as string | null | undefined;

    if (!value?.trim()) {
      return null;
    }

    return await normalizePhoneNumberToE164(value, defaultRegion)
      ? null
      : { invalidPhone: true };
  };
}
